import React from 'react';
import styled from 'styled-components';

const TermPage = () => {
  return (
    <Wrapper>
      <Header>닥터나우 약관 및 정책</Header>
      <SubHeaderWrapper>
        <SubHeader>
          <SubHeaderText>닥터나우 서비스 이용 약관</SubHeaderText>
          <Required>(필수)</Required>
        </SubHeader>
      </SubHeaderWrapper>
      <TermImage
        src={
          require('../../assets/images/agreement/serviceUseTerm.png')
        }
      />
      <SubHeaderWrapper>
        <SubHeader>
          <SubHeaderText>개인정보처리 위탁 계약</SubHeaderText>
          <Required>(필수)</Required>
        </SubHeader>
        <SubHeaderDescription>
          위탁자 &rdquo;닥터나우&ldquo;
        </SubHeaderDescription>
      </SubHeaderWrapper>
      <TermImage
        src={
          require('../../assets/images/agreement/privacyConsignment.png')
        }
      />
    </Wrapper>
  );
};

export default TermPage;

const Wrapper = styled.div`
  width: 100%;
  background-color: white;
  padding: 71px 149px;
`;

const Header = styled.h1`
  font-weight: 400;
  font-size: 28px;
  line-height: 34px;
`;

const SubHeaderWrapper = styled.div`
  margin-top: 60px;
  margin-bottom: 28px;
`;

const SubHeader = styled.h2`
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  display: flex;
`;

const SubHeaderText = styled.p``;

const SubHeaderDescription = styled.div``;

const Required = styled.p`
  color: #ff8d00;
`;

const TermImage = styled.img`
  width: 100%;
`;
